import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { Checkboxes } from "../../../FlowConfigurationInputs";

export default function Create({
  action,
  variables,
  setOpenVariable,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.FILE.";
  // checkbox options 
  const options = {
    checkboxes: { label: label + "OVERWRITE" },
  };
  return (
    <div>
      <div className="form-element">
        {t(label + "FILE")}
        <TextInput
          action={action}
          inputName="filePath"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
          extractPath="file"
          fieldType="string"
          displayName={t(label + 'FILE')}
        />
      </div>
      <div className="form-element">
        <Checkboxes
          action={action}
          inputName="overwriteFile"
          options={options.checkboxes}
        />
      </div>
    </div>
  );
}
